import { render, staticRenderFns } from "./DashboardFidFilters.vue?vue&type=template&id=beca2acc&"
import script from "./DashboardFidFilters.vue?vue&type=script&lang=js&"
export * from "./DashboardFidFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports